import React from 'react';
import './About1.css';

function About() {
  return (
    <div className="about-page">
      
      {/* Hero Image */}
      <div className="about-hero-image">
        <img src="/images/about-hero.jpg" alt="Sharanga Aqua Overview" />
      </div>

      {/* Vision & Mission Section */}
      <section className="vm-section">
        <div className="vision">
          <h2>Vision</h2>
          <p>
            Our vision is to cater and bring the best of sustainable and high-quality products to our clientele across the world. 
            We make sure to take steps towards being conscious of the impact we leave socially and environmentally.
          </p>
        </div>

        <div className="divider"></div>

        <div className="mission">
          <h2>Mission</h2>
          <ul>
            <li>Enhance and increase the capacities with state-of-the-art technology to meet the current demands across the world.</li>
            <li>Be a pioneer in creating efficiencies in the current manufacturing process and provide traceability to the end customer by leveraging on technology.</li>
            <li>Build and develop sustainable sourcing by increasing company-owned farms and directly working with aquaculture farmers in India.</li>
            <li>Reduce carbon and water footprint by 1% year after year.</li>
            <li>Create employment opportunities and contribute towards socio-economic development.</li>
          </ul>
        </div>
      </section>
       {/* About Description Section */}
      <section className="about-content-section">
        <h2>About Sharanga Aqua Farms</h2>
        <p>
          Sharanga Aqua Farms leads the aquaculture industry with responsible farming practices and full production control.
        </p>
        <p>
          From hatchery to harvest, our expert teams operate biosecure, modern facilities ensuring top product quality.
        </p>
        <p>
          We empower communities through farmer partnerships and training to foster inclusive, long-term livelihoods.
        </p>
        <p>
          Our exports meet international standards with Vannamei shrimp and tiger prawns for diverse global markets.
        </p>
        <p>
          Sharanga drives innovation in sustainability to protect oceans and serve customers with care and integrity.
        </p>
      </section>
    </div>
  );
}

export default About;
